import React from 'react';
import { useGetList, useRecordContext, useRedirect } from 'react-admin';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { LinearProgress } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import dayjs from 'dayjs';

import { FEEDBACK } from '../../../constants/resources';
import { typeUser as userType, CLIENT_BACKGROUND_COLOR } from '../constants';

const styles = {
	card: {
		marginBottom: '.5em',
		cursor: 'pointer',
	},
	caption: {
		marginLeft: '1em',
		color: 'grey',
	},
	client: {
		background: CLIENT_BACKGROUND_COLOR,
	},
	current: {
		background: '#ffe6ce',
	},
};

export default withStyles(styles)(({ classes }) => {
	const { uuid, id: currentId } = useRecordContext();
	const { data, isLoading } = useGetList(
		FEEDBACK,
		{
			filter: { uuid: uuid || '' },
			sort: { field: 'createdAt', order: 'ASC' },
			pagination: { page: 1, perPage: 1000 },
		},
	);

	const redirect = useRedirect();
	const getOnCardClickFn = (id) => () => redirect(`/${FEEDBACK}/${id}/show`);

	return (
		<Box>
			{isLoading && <LinearProgress />}
			{!isLoading && !data && <span>&mdash;</span>}
			{data && data.map(({
				id, updatedAt, typeUser, message,
			}) => {
				const isClientMessage = typeUser === userType.Client;
				const isCurrentMessage = id === currentId;
				const isCurrentAdminMessage = isCurrentMessage && !isClientMessage;
				const rowClasses = [
					classes.card,
					isClientMessage ? classes.client : '',
					isCurrentAdminMessage ? classes.current : '',
				]
					.filter((c) => Boolean(c))
					.join(' ');

				let captionText;
				if (isClientMessage) captionText = 'Сообщение от клиента';
				if (isCurrentAdminMessage) captionText = 'Текущее сообщение';

				return (
					<Card key={id} className={rowClasses} onClick={getOnCardClickFn(id)}>
						<Typography variant="caption" className={classes.caption}>
							{dayjs(updatedAt).format('DD.MM.YYYY \u00a0  HH:mm')}
						</Typography>
						{captionText ? (
							<Typography variant="caption" className={classes.caption}>{`(${captionText})`}</Typography>
						) : null}
						<CardContent>
							{message}
						</CardContent>
					</Card>
				);
			})}
		</Box>
	);
});

